<template>
  <el-dialog
    class="store-dialog"
    title="设置自动同步"
    :visible.sync="showDialog"
    :close-on-click-modal="false"
    :before-close="cancelAction"
    append-to-body
    width="1100px"
  >
    <!-- 查询区 -->
    <!-- 查询区 -->
    <ul class="search-btn">
      <li>
        <span class="m-r-6">销售群组</span>
        <SpSearchGroup @changeGroup="changeGroup" />
      </li>
      <li>
        <span class="m-r-6">门店编号</span>
        <el-input
          v-model="params.store_bn"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <span class="m-r-6">门店名称</span>
        <el-input
          v-model="params.store_name"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <el-button type="primary" @click="searchList"> 查询 </el-button>
      </li>
    </ul>

    <div style="margin-bottom: 15px" />
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="storeData"
      tooltip-effect="dark"
      :row-key="getRowKeys"
      @select="handleSelectionChange"
    >
      <el-table-column type="selection" :reserve-selection="true" width="50" />
      <el-table-column prop="store_bn" width="200px" label="门店编号" />
      <el-table-column prop="store_name" label="门店" />
    </el-table>
    <div class="tr" />
    <div slot="footer" class="dialog-footer select-footer">
      <div>
        <el-pagination
          layout="total, prev, pager, next, jumper"
          :total="total_count"
          :current-page="params.page"
          :page-size="params.page_size"
          @current-change="handleCurrentChange"
        />
      </div>
      <div>
        <!-- <span class="m-r-6">已选中{{ selectCount }}个门店</span> -->
        <el-button type="primary" :loading="submitLoading" @click="saveStoreAction">
          确定自动同步
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getStoreList } from '@/api/component'
export default {
  name: 'syncShop',
  model: {
    prop: 'showDialog',
    event: 'showDialogChange'
  },
  props: {
    showDialog: {
      // 展示选择门店的模态框
      type: Boolean,
      default: false
    },
    selectData: {
      // 已勾选的门店列表
      type: Array
    },
    submitLoading: {
      //提交的加载
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      storeData: [],
      multipleSelection: [],
      total_count: 0,
      params: {
        page: 1,
        page_size: 10,
        region: '',
        store_name: '',
        store_bn: ''
      },
      selectCount: 0,
      firstShow: false
    }
  },
  watch: {
    showDialog(newVal, oldVal) {
      if (newVal) {
        this.firstShow = true
        this.selectCount = this.selectData ? this.selectData.length : 0
        this.getNewsList('getFirst')
      }
    }
  },
  methods: {
    // 换页可选择
    getRowKeys(row) {
      return row.store_id
    },

    // 分页器页面切换
    handleCurrentChange(page_num) {
      this.params.page = page_num
      this.getNewsList()
    },

    // 查询门店
    searchList() {
      this.params.page = 1
      this.getNewsList()
    },

    // 全选事件
    selectAll(val) {
      this.multipleSelection = val
      this.selectCount = val.length
    },
    // table表格选择
    handleSelectionChange(val, row) {
      this.$refs.multipleTable.clearSelection()
      if (val.length === 0) {
        // 判断selection是否有值存在
        return
      }
      if (row) {
        this.multipleSelection = row
        this.$refs.multipleTable.toggleRowSelection(row, true)
      }
    },
    // 关闭模态框
    cancelAction() {
      this.$emit('showDialogChange', false)

      // 如果不需要默认勾选则关闭取消
      if (!this.selectData) {
        this.multipleSelection = []
        this.selectCount = 0
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 保存绑定
    saveStoreAction() {
      let result = []
      this.$refs.multipleTable.selection.forEach((v) => {
        result = result.concat(v.store_id)
      })
      this.$emit('chooseStore', this.multipleSelection, result)
    },
    // 获取门店列表
    async getNewsList(type) {
      this.loading = true
      const data = await getStoreList(this.params)
      if (data) {
        if (data.total_count < 1 && type === 'getFirst') {
          this.refreshStore('first')
        }
        this.loading = false
        this.storeData = data.list
        this.total_count = data.total_count

        // 获取选中元素 可传数组对象，也可传数组id
        if (this.firstShow) {
          this.firstShow = false
          this.toggleSelection(this.selectData)
        }
      }
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.clearSelection()

      if (rows && rows.length > 0) {
        rows.forEach((row) => {
          if (row && row.store_id) {
            // row = {contract_phone: "",region_id: "",store_bn: "",store_id: 615,store_name: ""}
            this.$refs.multipleTable.toggleRowSelection(row, true)
          } else {
            // row = 615
            let newrow = { store_id: row }
            this.$refs.multipleTable.toggleRowSelection(newrow, true)
          }
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },

    // 同步更新门店
    async refreshStore(type) {
      const data = await this.$api.component.refreshStore()
      if (data && type !== 'first') {
        this.$message({
          message: '更新同步成功',
          type: 'success'
        })
      }
    },

    // 群组查询
    changeGroup(val) {
      if (val && val.length > 0) {
        this.params.group_code = val[val.length - 1]
      } else {
        this.params.group_code = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}
.select-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep {
  .el-table__header {
    .el-table-column--selection {
      .cell {
        .el-checkbox {
          display: none;
        }
      }
    }
  }
}
</style>
